import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
// TODO: Layout is the highest Layer. It's not able to be imported. Maybe windowWidth should be in App.
import { windowWidth as windowWidthSelector } from 'modules/Layout/selectors';
const prepareTicks = (ticks, start, end, windowWidth)=>{
    let firstTick;
    let lastTick;
    const tickValues = ticks || [];
    const tickParts = [];
    if (!ticks) {
        ticks = [];
        const daySeconds = 86400;
        firstTick = +moment.unix(start).utc().locale('en--account').startOf('day').format('X');
        lastTick = +moment.unix(end).utc().locale('en--account').startOf('day').add(1, 'days').format('X');
        const difference = (lastTick - firstTick) / daySeconds;
        const maxNofElements = windowWidth > 1680 ? 14 : 10;
        const multiplier = Math.max(Math.ceil(difference / maxNofElements), 1);
        for(let i = firstTick; i <= lastTick; i += daySeconds * multiplier){
            if (tickValues.length >= maxNofElements) break;
            tickValues.push(i);
        }
    } else {
        firstTick = ticks[0];
        lastTick = ticks[ticks.length - 1];
    }
    const totalDiff = lastTick - firstTick;
    for(let index = 1; index < tickValues.length; index++){
        const elementStart = tickValues[index - 1];
        const elementEnd = tickValues[index];
        const elementDiff = elementEnd - elementStart;
        tickParts.push({
            start: elementStart,
            end: elementEnd,
            width: elementDiff / totalDiff
        });
    }
    return {
        firstTick,
        lastTick,
        tickValues,
        tickParts
    };
};
export const useTicks = (ticks, start, end)=>{
    const windowWidth = useSelector(windowWidthSelector);
    const [firstTick, setFirstTick] = useState(0);
    const [lastTick, setLastTick] = useState(0);
    const [tickValues, setTickValues] = useState([]);
    const [tickParts, setTickParts] = useState([]);
    useEffect(()=>{
        const chartTicks = prepareTicks(ticks, start, end, windowWidth);
        setFirstTick(chartTicks.firstTick);
        setLastTick(chartTicks.lastTick);
        setTickValues(chartTicks.tickValues);
        setTickParts(chartTicks.tickParts);
    }, [
        ticks,
        start,
        end
    ]);
    return {
        firstTick,
        lastTick,
        tickValues,
        tickParts
    };
};
